<script lang="ts" setup>
import type { Category, Items } from '~~/server/api/menu/main'

const props = defineProps<{
    category: Items
    parentCategory: Category
    isActive?: boolean
}>()
const activeSubmenu = useState('activeSubmenu')

const { $t } = useNuxtApp()
</script>
<template>
  <li class="submenu-category-item mb-1 mb-md-0">
    <LazySubmenuLink
      :category="props.category"
      :is-active="props.isActive"
    />
    <section
      v-if="
        props.category.products &&
          (props.category.products?.length > 0 ||
            props.category.items.length > 0)
      "
      class="submenu-category-content transiton ps-md-3 pe-md-3 pt-md-3"
    >
      <button
        class="submenu-category-back text-start z-index-5 box-shadow-1 d-block bg-transparent p-0 w-100 d-md-none fs-big fw-bold m-0 text-black d-flex align-items-center p-4 mb-4"
        @click.prevent="activeSubmenu = null"
      >
        <img
          loading="lazy"
          decoding="async"
          src="~/assets/icons/long-arrow-left.svg"
          class="me-2"
          width="18"
          height="8"
          alt=""
        >
        {{ $t('Späť') }}
      </button>
      <VNuxtLink
        class="submenu-category-sublink text-black text-decoration-none fw-bold bg-white d-none d-md-flex py-2 fs-small px-2 px-md-4 mb-2 rounded-3 justify-content-between align-items-center"
        :to="{
          name: 'insurance-category-detail',
          params: { id: props.category.slug },
        }"
      >
        {{ $t('Zobraziť kategóriu') }} {{ props.category.title }}
        <img
          loading="lazy"
          decoding="async"
          src="~/assets/icons/long-arrow-right.svg"
          class="ms-2"
          alt=""
          width="18"
          height="8"
        >
      </VNuxtLink>

      <SubmenuCategoryTitle
        :icon="props.category.icon?.path"
        :title="props.category.title"
        :slug="props.category.slug"
        class="mb-6 d-md-none"
      />

      <template v-if="props.category.items.length > 0">
        <LazySubmenuCategoryProductsGroup
          v-for="(item, index) in props.category.items"
          :key="`smsc-${index}`"
          :products="item.products"
          :title="item.title"
          :category-slug="props.category.slug"
        />
      </template>
      <LazySubmenuCategoryProductsGroup
        v-if="props.category.products.length > 0"
        :products="props.category.products"
        :title="$t('Produkty')"
        :category-slug="props.category.slug"
      />
    </section>
  </li>
</template>
<style lang="scss">
@import './SubmenuCategory.scss';
</style>
